const adminApiBaseUrl =
  process.env.REACT_APP_PAYMENT_API_URL ||
  'https://southamerica-east1-coloniadeferiasss.cloudfunctions.net/paymentApi';

export type CampoPresenca = 'entrada' | 'saida' | 'piscina';

export interface PresencaDia {
  entrada?: boolean;
  saida?: boolean;
  horarioEntrada?: string;
  horarioSaida?: string;
  piscina?: string;
}

export interface ChamadaDia {
  id: string;
  data: string;
  presencas: Record<string, PresencaDia>;
}

export const fetchTodasChamadas = async (): Promise<ChamadaDia[]> => {
  const response = await fetch(`${adminApiBaseUrl.replace(/\/$/, '')}/admin/chamadas/todas`);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.success) throw new Error(payload.error || 'Não foi possível carregar as chamadas.');
  return Array.isArray(payload.chamadas) ? payload.chamadas : [];
};

/** Uma marcação ainda não confirmada pelo servidor — persistida localmente pra sobreviver
 * a um reload ou a ficar offline até conseguir sincronizar. */
export interface AcaoPendente {
  /** `${data}:${inscricaoId}:${campo}` — usada pra nunca empilhar duas marcações do mesmo
   * campo: a mais nova substitui a mais velha, só o estado final importa. */
  chave: string;
  data: string;
  inscricaoId: string;
  campo: CampoPresenca;
  valor: boolean;
  horario?: string;
  criadoEm: number;
}

const FILA_STORAGE_KEY = 'colonia:chamada:fila-pendente';

export const carregarFilaPendente = (): AcaoPendente[] => {
  try {
    const bruto = localStorage.getItem(FILA_STORAGE_KEY);
    if (!bruto) return [];
    const lista = JSON.parse(bruto);
    return Array.isArray(lista) ? lista : [];
  } catch {
    return [];
  }
};

export const salvarFilaPendente = (fila: AcaoPendente[]) => {
  try {
    localStorage.setItem(FILA_STORAGE_KEY, JSON.stringify(fila));
  } catch {
    // localStorage indisponível (modo privado, cota cheia etc.) — a fila só não
    // sobrevive a um reload, mas a sessão atual continua tentando sincronizar.
  }
};

/**
 * Atualiza só o campo de UMA criança no Firestore (caminho aninhado), nunca o mapa do dia
 * inteiro — é o que permite dois dispositivos (ou a portaria offline sincronizando depois)
 * marcarem ao mesmo tempo sem um apagar a marcação do outro.
 */
export const marcarPresenca = async (
  data: string,
  inscricaoId: string,
  campo: CampoPresenca,
  valor: boolean,
  horario?: string
): Promise<void> => {
  const response = await fetch(`${adminApiBaseUrl.replace(/\/$/, '')}/admin/chamadas/marcar`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ data, inscricaoId, campo, valor, horario })
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    throw new Error(payload?.error || 'Não foi possível salvar a marcação.');
  }
};
